/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import PlaybookLogsQuery$parameters from '@jira/playbooks__list-screen/src/__generated__/PlaybookLogsQuery$parameters.ts';
import type { PlaybookLogsQuery } from '@jira/playbooks__list-screen/src/__generated__/PlaybookLogsQuery.graphql.ts';

type Queries = { PlaybookLogsQuery: PlaybookLogsQuery };

type ExtraProps = {
	projectKey: string | null | undefined;
};

type PlaybookLogsViewEntryPointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

const playbookLogsViewEntryPoint: EntryPoint<
	PlaybookLogsViewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PlaybookLogsViewEntryPointComponent>(
		/* webpackChunkName: "async-spa-apps-playbooks-logs" */ './index.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { projectKey } = context.match.params;
		const { name = '' } = context.query;

		if (!projectKey) {
			throw new Error('projectKey is required');
		}

		return {
			queries: {
				PlaybookLogsQuery: {
					parameters: PlaybookLogsQuery$parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey,
						first: PLAYBOOK_LOGS_FIRST_COUNT,
						filter: name ? { name } : null,
					},
				},
			},
			extraProps: {
				projectKey: context.match.params.projectKey,
			},
		};
	},
});
const PLAYBOOK_LOGS_FIRST_COUNT = 20;

export default playbookLogsViewEntryPoint;
